import React from 'react';
import { Link } from 'react-router-dom';
import toast from '../utils/toast';
import { mapSetupError } from '../utils/friendlyErrors';
import './SetupErrorMessage.css';

// Shows a backend "missing key" error as friendly text with an "Open Settings" link to the right
// card. Any other message is shown unchanged (or the fallback when there is no message).
export default function SetupErrorMessage({ message, fallback }) {
  const mapped = mapSetupError(message);
  if (!mapped) return <>{message || fallback || null}</>;
  return (
    <span className="setup-error" title={message}>
      {mapped.prefix}{mapped.text}
      {mapped.link && (
        <>
          {' '}
          <Link to={mapped.link} className="setup-error-link">Open Settings</Link>
        </>
      )}
    </span>
  );
}

// Error toast that uses the friendly text + link for setup errors (Toaster sits inside the Router).
export function toastSetupError(message, fallback) {
  if (!mapSetupError(message)) return toast.error(message || fallback);
  return toast.error(<SetupErrorMessage message={message} />, { duration: 8000 });
}
